import { Store } from "@tanstack/react-store";

const authStore = new Store({
    userEmail: null as string | null,
    userConsentsAreAccepted: null as boolean | null,
    hasBeenRedirectedToConsent: false as boolean,
    isLoggingOut: false as boolean,
});

export const resetAuthStore = () => {
    authStore.setState((prevState) => ({
        ...prevState,
        userEmail: null,
        userConsentsAreAccepted: null,
        hasBeenRedirectedToConsent: false,
    }));
};

export default authStore;
